module.exports = __webpack_public_path__ + "img/exam-content-paper.a7f9835c.png";